import React, { useEffect, type ReactNode } from 'react';
import { initializeLocale } from '@utils/datetime';
import { reportTimezoneConsistency } from '@utils/timezone';

export const LocaleProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  useEffect(() => {
    initializeLocale();
    // Observe-only: logs when the browser's zone name and clock offset disagree.
    // Deliberately does NOT cache the timezone the way the locale above is
    // cached — locale effectively never changes mid-session, whereas a timezone
    // changes whenever the user moves, and this app stays resident for days as
    // a PWA and a Capacitor shell. Timezone reads stay lazy at their call sites.
    reportTimezoneConsistency();
  }, []);
  return <>{children}</>;
};
